import { useHome } from "./use-home";
import { HomeView } from "./view-home";

export function HomeScreen() {
  const vm = useHome();

  return <HomeView {...vm} />;
}

export type * from "./types-home";
